import { render, staticRenderFns } from "./CustomFormAnswerSubmission.vue?vue&type=template&id=0125b87a&"
import script from "./CustomFormAnswerSubmission.vue?vue&type=script&lang=js&"
export * from "./CustomFormAnswerSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports